import React from "react";
import { Link } from "react-router-dom";

export default function TermsPage() {
  return (
    <div className="bg-gradient-to-b from-orange-400 via-orange-100 to-white min-h-screen flex flex-col">
      {/* Animated SVG/CSS background for the entire page */}
      <div className="fixed inset-0 pointer-events-none z-0 w-full h-full">
        <svg width="100%" height="100%" className="w-full h-full animate-pulse-slow" style={{position:'absolute',top:0,left:0}}>
          <circle cx="30%" cy="30%" r="180" fill="none" stroke="#fbb6ce" strokeWidth="2" opacity="0.2">
            <animate attributeName="r" values="180;200;180" dur="6s" repeatCount="indefinite" />
          </circle>
          <circle cx="70%" cy="60%" r="120" fill="none" stroke="#a5b4fc" strokeWidth="2" opacity="0.15">
            <animate attributeName="r" values="120;140;120" dur="7s" repeatCount="indefinite" />
          </circle>
          <path d="M 0 400 Q 400 200 1200 400" stroke="#f472b6" strokeWidth="1.5" fill="none" opacity="0.12">
            <animate attributeName="d" values="M 0 400 Q 400 200 1200 400;M 0 420 Q 400 220 1200 420;M 0 400 Q 400 200 1200 400" dur="8s" repeatCount="indefinite" />
          </path>
        </svg>
      </div>
      {/* Header */}
      <nav className="relative z-10 w-full flex items-center justify-between px-20 py-6 bg-transparent">
        <div className="flex items-center gap-2">
          <img src="/icons/icon.svg" alt="Logo" className="h-8 w-8" />
          <span className="text-2xl font-bold text-gray-900 tracking-tight">Hintword</span>
        </div>
      </nav>
      <main className="flex-1 flex flex-col items-center justify-center px-4 py-16 z-10">
        <div className="max-w-5xl w-full bg-white/90 rounded-xl shadow-md p-8">
          <h1 className="text-3xl font-bold mb-6 text-gray-900">Terms of Service</h1>
          <p className="mb-4 text-gray-700">
            Welcome to Hintword Studio! By accessing or using our service, you agree to be bound by these Terms of Service. Please read them carefully.
          </p>
          <h2 className="text-xl font-semibold mt-6 mb-2">1. Use of Service</h2>
          <p className="mb-4 text-gray-700">
            Hintword Studio provides a workspace for managing browser tabs, taking notes, and using AI-powered productivity tools. You agree to use the service only for lawful purposes and in accordance with these terms.
          </p>
          <h2 className="text-xl font-semibold mt-6 mb-2">2. User Content</h2>
          <p className="mb-4 text-gray-700">
            You are responsible for the content you create, upload, or share using Hintword Studio. Do not use the service to store or distribute unlawful, harmful, or offensive material.
          </p>
          <h2 className="text-xl font-semibold mt-6 mb-2">3. Privacy</h2>
          <p className="mb-4 text-gray-700">
            Your privacy is important to us. Please review our <a href="/privacy" className="text-primary underline">Privacy Policy</a> to understand how we collect, use, and protect your information.
          </p>
          <h2 className="text-xl font-semibold mt-6 mb-2">4. AI Features</h2>
          <p className="mb-4 text-gray-700">
            Some features of Hintword Studio use AI to enhance your productivity. AI-generated suggestions are for informational purposes only and may not always be accurate.
          </p>
          <h2 className="text-xl font-semibold mt-6 mb-2">5. Changes to Service</h2>
          <p className="mb-4 text-gray-700">
            We may update or discontinue features at any time. We will try to provide notice of significant changes.
          </p>
          <h2 className="text-xl font-semibold mt-6 mb-2">6. Disclaimer</h2>
          <p className="mb-4 text-gray-700">
            Hintword Studio is provided "as is" without warranties of any kind. We are not liable for any damages resulting from your use of the service.
          </p>
          <h2 className="text-xl font-semibold mt-6 mb-2">7. Contact</h2>
          <p className="mb-4 text-gray-700">
            If you have questions about these terms, contact us at <a href="mailto:support@hintword.com" className="text-primary underline">support@hintword.com</a>.
          </p>
        </div>
      </main>
      {/* Footer */}
      <footer className="w-full py-8 px-8 flex flex-col md:flex-row items-center justify-between bg-white border-t border-gray-200 mt-auto relative z-10">
        <div className="flex items-center gap-2 text-gray-400 text-sm">
          <img src="/icons/icon.svg" alt="Logo" className="h-6 w-6" />
          <span>Hintword</span>
        </div>
        <div className="flex gap-6 text-gray-400 text-sm mt-4 md:mt-0">
          {/* <a href="/help" className="hover:underline">Help Center</a>
          <a href="/feedback" className="hover:underline">Feedback</a>
          <a href="/pricing" className="hover:underline">Pricing</a> */}
          <a href="/terms" className="hover:underline">Terms</a>
          <a href="/privacy" className="hover:underline">Privacy</a>
        </div>
      </footer>
    </div>
  );
} 